import { TranslationRequestStatusEnum } from 'gql/graphql';
import { KeysRecentActivities, RecentActivityExtended } from '..';

export const getTitleActivityFactory = (value: RecentActivityExtended) => {
  const titleTranslation = 'title' in value.trackable ? value.trackable.title : '';

  if (titleTranslation) return titleTranslation;

  const title =
    'translationRequest' in value.trackable ? value.trackable.translationRequest?.title : '';

  if (title) return title;

  return '';
};

export const getInitTextHrefTitleAndEndTextFactory = (
  activity: RecentActivityExtended,
  t: (key: any) => string
) => {
  const title = getTitleActivityFactory(activity);
  const version = 'version' in activity.trackable ? activity.trackable.version : '';
  const text = 'text' in activity.trackable ? activity.trackable.text : '';
  const taskId = 'task' in activity.trackable ? activity.trackable.task?.id : '';

  if (
    activity?.key === KeysRecentActivities.TranslationRequestChanged ||
    activity?.key === KeysRecentActivities.TranslationRequestCreated
  )
    return {
      href:
        activity?.key === KeysRecentActivities.TranslationRequestCreated
          ? '#'
          : activity?.parameters?.to_status === TranslationRequestStatusEnum.Unordered
          ? `/translation/translation-requests?quote=${version}`
          : `/translation/show-translation/${version}`,
      init: t('dashboard.recent_activities.states.tr.title'),
      title: title?.includes(`(#${version})`) ? title : `${title} (#${version})`,
      status: activity?.parameters?.to_status,
      ...{
        ...(activity?.parameters?.to_status === TranslationRequestStatusEnum.InTranslation && {
          end: t('dashboard.recent_activities.states.tr.states.in_progress')
        }),
        ...(activity?.parameters?.to_status === TranslationRequestStatusEnum.Unordered && {
          end: t('dashboard.recent_activities.states.tr.states.quoted')
        }),
        ...(activity?.parameters?.to_status === TranslationRequestStatusEnum.WaitingForClient && {
          end: t('dashboard.recent_activities.states.tr.states.ready_to_review')
        }),
        ...(activity?.parameters?.to_status === TranslationRequestStatusEnum.Finished && {
          end: t('dashboard.recent_activities.states.tr.states.finished')
        }),
        ...(activity?.parameters?.to_status === TranslationRequestStatusEnum.Canceled && {
          end: t('dashboard.recent_activities.states.tr.states.cancelled')
        }),
        ...(!activity?.parameters?.to_status && {
          end: t('dashboard.recent_activities.states.tr.states.created')
        })
      }
    };

  if (activity?.key === KeysRecentActivities.CommentCreated)
    return {
      href: `/translation/show-task/${taskId}#comments`,
      init: t('dashboard.recent_activities.states.comment.title'),
      title,
      text,
      status: '',
      end: ''
    };

  if (activity?.key === KeysRecentActivities.ThreadCreated) {
    return {
      href: `/smart-tasks/chat-ai/${activity.trackable?.id}`,
      init: t('dashboard.recent_activities.states.chat.title'),
      title: title?.at(title.length - 1) === '.' ? title?.slice(0, -1) : title,
      status: '',
      end: ''
    };
  }

  if (activity?.key === KeysRecentActivities.GeneratedContentCreate) {
    return {
      href: `/content-creator/${activity.trackable?.id}`,
      init: t('dashboard.recent_activities.states.content_generation.title'),
      title: title?.at(title.length - 1) === '.' ? title?.slice(0, -1) : title,
      status: '',
      end: ''
    };
  }

  return { href: '', init: '', title: '', text: '', status: '', end: '' };
};
